var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33952 2.62707C0.761979 2.62707 0.294482 2.15957 0.294482 1.58203C0.294482 1.00449 0.761979 0.536996 1.33952 0.536996L9.69537 0.538473C10.2722 0.539211 10.7404 1.00745 10.7404 1.58351C10.7404 2.16105 10.2729 2.62854 9.69537 2.62854L1.33952 2.62707Z",
    fill: "#00ABE8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.02e642652dacdcb7320a246d524bc3c9.svg";
export { ForwardRef as ReactComponent };